/* Keep purchase intent separate from Shopify's internal pricing variant. */
(() => {
  if (window.MioRingSize) return;
  const states = new WeakMap();
  const rootFor = el => el?.closest('[data-mio-ring-size]');
  const purchaseFlow = () => document.documentElement.classList.contains('mio-pdp-v3');
  function state(root) {
    if (!states.has(root)) states.set(root, { size: '', pending: false, revision: 0 });
    return states.get(root);
  }
  const picker = root => root.querySelector('[data-mio-size-option]');
  function variant(root) {
    try { return JSON.parse(root.querySelector('[data-selected-variant]')?.textContent || 'null'); }
    catch { return null; }
  }
  function message(root, text = '') {
    const output = root.querySelector('[data-mio-size-error]');
    if (output) { output.textContent = text; output.hidden = !text; }
    const controls = picker(root)?.querySelectorAll('.mio-dd__trigger, .mio-option-chips') || [];
    controls.forEach(control => control.setAttribute('aria-invalid', text ? 'true' : 'false'));
  }
  function sync(root) {
    const s = state(root);
    root.dataset.mioChosenSize = s.size;
    const button = root.querySelector('[id^="x-atc-button-"]');
    const text = button?.querySelector('.x-atc-text');
    if (text && !button.disabled) {
      if (purchaseFlow()) {
        text.textContent = 'Add to cart';
        return;
      }
      const prompt = root.dataset.mioSizePrompt || 'Select ring size';
      if (!s.size) {
        if (text.textContent.trim() !== prompt) s.addLabel = text.textContent.trim();
        text.textContent = prompt;
      } else if (text.textContent.trim() === prompt && s.addLabel) text.textContent = s.addLabel;
    }
  }
  function focus(root) {
    const group = picker(root);
    const trigger = group?.querySelector('.mio-dd__trigger, [data-mio-size-chip]:not(:disabled)') || group?.querySelector('select, input');
    if (!trigger) return;
    trigger.scrollIntoView({ block: 'center', behavior: 'smooth' });
    trigger.focus({ preventScroll: true });
    if (purchaseFlow() && trigger.matches('.mio-dd__trigger')) {
      // Main ATC runs inside a click handler. Open after that click's outside
      // handlers have finished, or the same click immediately closes the menu.
      setTimeout(() => {
        if (trigger.isConnected && !state(root).size) {
          trigger.closest('.mio-dd')?.dispatchEvent(new CustomEvent('mio:request-size'));
        }
      }, 0);
    }
  }
  function matches(root, current) {
    if (!current?.available) return false;
    return [...root.querySelectorAll('.variant-selects [data-option-index]')].every(group => {
      const value = group.querySelector('select')?.value || group.querySelector('input:checked')?.value;
      return !value || current.options[Number(group.dataset.optionIndex)] === value;
    });
  }
  window.MioRingSize = {
    restore(el, size) {
      const root = rootFor(el);
      if (!root) return;
      const current = variant(root);
      const s = state(root);
      s.size = current?.available && current.options[Number(root.dataset.mioRingSize)] === size ? size : '';
      s.pending = false;
      sync(root);
    },
    mount(el) { const root = rootFor(el); if (root) sync(root); },
    value(el) { const root = rootFor(el); return root ? state(root).size : ''; },
    label(el) {
      const root = rootFor(el);
      if (root && purchaseFlow()) return 'Add to cart';
      return root && !state(root).size ? root.dataset.mioSizePrompt || 'Select ring size' : '';
    },
    begin(el) {
      const root = rootFor(el);
      if (!root) return;
      const s = state(root);
      s.pending = true;
      return ++s.revision;
    },
    accepts(el, revision) {
      if (el?.isConnected === false) return false;
      const root = rootFor(el);
      return !root || revision === state(root).revision;
    },
    finish(el, revision) {
      const root = rootFor(el);
      if (!root || revision !== state(root).revision) return;
      const s = state(root), current = variant(root);
      s.pending = false;
      if (s.size && (!matches(root, current) || current.options[Number(root.dataset.mioRingSize)] !== s.size)) {
        s.size = '';
        message(root, 'Please choose an available ring size for this combination.');
      } else message(root);
      sync(root);
    },
    fail(el, revision) {
      const root = rootFor(el);
      if (!root || revision !== state(root).revision) return;
      // Keep the guard closed until a selection successfully resolves.
      message(root, 'Your selection could not be updated. Please select it again.');
    },
    guard(el, submittedId) {
      if (el?.isConnected === false) return false;
      const root = rootFor(el);
      if (!root) return true;
      const s = state(root), current = variant(root);
      if (!s.size) {
        message(root, purchaseFlow() ? 'Please choose your size to continue.' : 'Please select your ring size.');
        focus(root);
        return false;
      }
      if (s.pending || !matches(root, current) || (submittedId !== undefined && String(submittedId) !== String(current.id)) || String(current.id) !== root.querySelector('form[data-type="add-to-cart-form"] input[name="id"], form input[name="id"]')?.value) {
        message(root, 'Please wait for your selection to finish updating.');
        return false;
      }
      message(root);
      return true;
    }
  };
  document.addEventListener('change', event => {
    const el = event.target, root = rootFor(el);
    if (!root || !el.matches('.variant-selects select, .variant-selects input[type="radio"]')) return;
    const s = state(root);
    if (el.closest('[data-mio-size-option]')) {
      const option = el.selectedOptions?.[0];
      s.size = option?.dataset.available === 'false' || el.disabled ? '' : el.value;
    }
    s.pending = true;
    ++s.revision; // Invalidate the previous response before the deferred request begins.
    message(root);
    sync(root);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches('form[data-type="add-to-cart-form"]') && !window.MioRingSize.guard(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  const init = () => document.querySelectorAll('[data-mio-ring-size]').forEach(sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
